import gButton from "@/components/g-button/g-button";
import gForm from "@/components/g-form/g-form";
import gCard from "@/components/g-card/g-card.vue"
import gSteps from "@/components/g-steps/g-steps.vue";
import gMenuSidebar from "@/components/g-menu-sidebar/g-menu-sidebar.vue";
import { useVuelidate } from "@vuelidate/core";
import { defineComponent } from "vue";
import PedidoController from "@/shared/controllers/pedido/PedidoController";
import ChecklistAmostraLoteViewModel from "@/shared/view-models/ChecklistAmostraLoteViewModel";
// import { helpers, required } from "@vuelidate/validators";

const name = 'PedidoAmostraLote'

export default defineComponent({
  name,

  components: {
    'g-form': gForm,
    'g-button': gButton,
    'g-card': gCard,
    'g-steps':gSteps,
    'g-menu-side-bar':gMenuSidebar,
  },

  props: { },

  setup(){
    return {
      v$: useVuelidate()
    }
  },

  mounted () {
    this.GetDataConsumoEnum();
    this.getAmostraLote();
    this.habilitarcampo();
  },

  updated () { },

  data () {
    return {
      Pedido: {},
      Representante:{},
      Empresa: '',
      Cliente:{},
      informacoesCliente: {},
      popup: false,
      PedidoId  : null,

      hologacaoFornecedor : false,
      aprovacaoCor : false,
      colecaoCliente : false,
      aprovacaoMaquina : false,
      aprovacaoMateria : false,
      necessidadeTecnica : false,
      exportacaoExigencia : false,
      custoAprovado : false,
      materialDiferente : false,
      arquivoEletronico : false,
      cartelasCor : false,
      homologadoConcorrente : false,
      checkboxQual : false,
      textQual: "",
      checkboxOutros : false,
      textOutros : "",
      DataConsumo: 0,
      loteArray: [],
      // ProdutoIndustrializacaoComercializacao: false,
      checkboxReprovacao : false,
      reprovacaoAnexo : false,
      novoCheckAmostra: new ChecklistAmostraLoteViewModel()
    }
  },

  methods: {
    voltarstep4(){
      this.novoCheckAmostra = new ChecklistAmostraLoteViewModel()
      this.$router.push(`/gerar-novo-pedido/${this.$route.params.id}/carac-produto-pedido`)
    },

    habilitarcampo(){
      if(this.binary == true){
        this.disabled = false;
      }
    },

    abrePopup() {
    if (this.novoCheckAmostra.DescricaoConsumo == undefined) {
      this.$toast.add({ severity: 'info', summary: '"É necessário informar um valor para o campo Consumo previsto para o produto!"', life: 6000 });
      return;
    }

    if (this.novoCheckAmostra.ProdutoIndustrializacaoComercializacao == null) {
      this.$toast.add({ severity: 'info', summary: 'É necessário selecionar uma opção "Sim" ou "Não" para "Produto será utilizado no processo de industrialização ou comercialização ?"', life: 7000 });
      return;
    }

    if(this.novoCheckAmostra.ProdutoIndustrializacaoComercializacao == 1) {
      this.novoCheckAmostra.ProdutoIndustrializacaoComercializacao = true; 
      }
    else {
      this.novoCheckAmostra.ProdutoIndustrializacaoComercializacao = false;
      }
      this.popup = true;
      PedidoController.postAmostraLote(this.$route.params.id, this.novoCheckAmostra)

    },
    camponumero($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57)) { // 46 is dot
        $event.preventDefault();
      }
    },

    fechaPopup() {
      this.popup = false;
    },

    industrialicao(){
      this.tipoProduto === "2" ? this.riscoFaca= true : this.riscoFaca=false
      this.tipoProduto === "1" ? this.prototipo= true : this.prototipo=false
    },
    finalizacao() {
      this.fechaPopup();
      this.$router.push(`/pedido-final/${this.$route.params.id}`)
    },

    getAmostraLote(){
      this.PedidoId = this.$route.params.id;
      this.axios({
        method:'get',
        url:process.env.VUE_APP_WEB_API + `Pedido/AmostraLote/${this.PedidoId}`,
      })
        .then((response) => {
          this.Pedido = response.data.data.codigoExt;
          this.Representante = response.data.data.nomeRepresentante;
          this.Empresa = response.data.data.nomeEmpresa;
          this.Cliente = response.data.data.nomeFantasia;
        })
        .catch();
    },
    GetDataConsumoEnum(){
      this.PedidoId = this.$route.params.id;
      this.axios({
        method:'get',
        url:process.env.VUE_APP_WEB_API + `Pedido/GetDataConsumoEnum`,
      })
        .then((response) => {
          this.loteArray = response.data
        })
        .catch();
    },
    GetAmostraLoteCheckInfos(){
      PedidoController.GetAmostraLoteCheckInfos().requisicao
        .then((res => {
          this.novoCheckAmostra = res.data.data
        }))
        .catch()
    },

    verificaCampoVazio(campo){
      if (campo === undefined || campo === null || campo === "" || campo === '')
        return true
      else 
        return false
    },

    checkConcorrente() {
      if (this.novoCheckAmostra.ProdutoFeitoPorConcorrente === true)
        this.novoCheckAmostra.NomeConcorrente = undefined
    },

    checkOutros() {
      if (this.novoCheckAmostra.ProdutoFeitoPorConcorrente === true)
        this.novoCheckAmostra.NomeConcorrente = undefined
    },
    checkReprovacao() {
      if (this.novoCheckAmostra.Reprovacao === true)
        this.novoCheckAmostra.MotivoReprovacao = undefined
    }

  },

  computed: { },

});

